import React, { useCallback } from 'react';
import { TextV2 } from '@withjoy/joykit';
import { LayoutAddComponentListItem } from '@website-editor/features/custom-page/components/LeftPanelLayouts/LayoutAddComponentListItem';
import { useCreateNewJsonComponent } from '../hooks/useJsonBlobStorageUtils';
import { Profile } from '@withjoy/joykit/icons';
import { AdminSidebarComponentProps } from '../JsonComponent.types';
import { SimpleGrabHandle } from '@website-editor/components/SimpleGrabHandle';
import { VipConfig } from './Vip.config';
import { useTranslation } from '@shared/core';
import { useUpdateWebsitePreview } from '@website-editor/hooks/useUpdateWebsitePreview';
import { useCustomComponentStateContext } from '@website-editor/features/custom-page/context/CustomComponentStateContext/CustomComponentState.context';
import { JsonDataBlobComponentFragment, JsonDataContainerFragment } from '@graphql/generated';
import { useWebsiteEditorCustomBlocksConfig } from '../hooks/useWebsiteEditorCustomBlocksConfig';
import { useGoToEditorView } from '../hooks/useJsonComponentNavigation';

export const VipGrabber = (props: AdminSidebarComponentProps) => {
  const { tq } = useTranslation('VIPCustomComponent');
  const customBlocksConfig = useWebsiteEditorCustomBlocksConfig(tq);
  const vipConfigs = customBlocksConfig?.vip;

  return (
    <SimpleGrabHandle
      title={vipConfigs?.componentTitle || tq`VIPs`}
      icon={<Profile size={32} />}
      {...props}
    ></SimpleGrabHandle>
  );
};

export const VipAdd = (props: AdminSidebarComponentProps) => {
  const { createNewJsonComponent } = useCreateNewJsonComponent(props.eventHandle);
  const { setRefetchQueries } = useCustomComponentStateContext<JsonDataContainerFragment>();
  const { updateWebsitePreview } = useUpdateWebsitePreview();
  const { goToEditorView } = useGoToEditorView();
  const { tq } = useTranslation('VIPCustomComponent');
  const customBlocksConfig = useWebsiteEditorCustomBlocksConfig(tq);
  const vipConfigs = customBlocksConfig?.vip;

  const handleClick = useCallback(async () => {
    const result = await createNewJsonComponent({
      schemaURL: VipConfig.schemaUrl,
      type: VipConfig.componentType,
      initialData: {},
      containerId: props.containerId,
      sortOrder: props.componentData.sortOrder,
    });
    if (result?.componentData && result?.containerData?.data) {
      setRefetchQueries(['PageContainerBySlug']);
      updateWebsitePreview();
      // Construct full fragment combining component and container data
      const fullComponentData: JsonDataBlobComponentFragment = {
        ...result.componentData,
        __typename: 'JsonDataBlobComponent',
        containerContent: result.containerData.data,
      };
      goToEditorView(fullComponentData);
    }
  }, [createNewJsonComponent, goToEditorView, props.componentData.sortOrder, props.containerId, setRefetchQueries, updateWebsitePreview]);

  return (
    <LayoutAddComponentListItem onClick={handleClick}>
      <Profile size={48} />
      <TextV2
        typographyVariant="hed2"
        textAlign="left"
      >
        {vipConfigs?.componentTitle || tq`VIPs`}
      </TextV2>
    </LayoutAddComponentListItem>
  );
};
